var _ellipse, _ellipse2, _path, _circle, _circle2, _circle3, _circle4, _path2, _path3, _path4, _circle5, _circle6, _circle7, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle8, _circle9, _circle10, _path13, _path14, _ellipse3, _circle11, _circle12, _circle13, _circle14, _path15, _path16, _path17, _circle15, _circle16, _path18, _path19, _ellipse4, _ellipse5, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle17, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _circle18, _path38, _path39, _path40, _path41, _path42, _polygon, _path43, _path44, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTtt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 950.5,
    height: 621.22833,
    viewBox: "0 0 950.5 621.22833",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 129,
    cy: 605.72833,
    rx: 129,
    ry: 15,
    fill: "#e6e6e6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 821.5,
    cy: 606.22833,
    rx: 129,
    ry: 15,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M918.63237,472.57649H265.17081a6.92409,6.92409,0,0,1-6.916-6.91594V146.30178a6.92409,6.92409,0,0,1,6.916-6.916H918.63237a6.92409,6.92409,0,0,1,6.91594,6.916V465.66055A6.92408,6.92408,0,0,1,918.63237,472.57649ZM265.17081,142.15221a4.1541,4.1541,0,0,0-4.14957,4.14957V465.66055a4.1541,4.1541,0,0,0,4.14957,4.14956H918.63237a4.15411,4.15411,0,0,0,4.14957-4.14956V146.30178a4.15411,4.15411,0,0,0-4.14957-4.14957Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 444.16772,
    cy: 128.03869,
    r: 10.72581,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.16772,
    cy: 128.03869,
    r: 6.89516,
    fill: "#0ac5a8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 490.13546,
    cy: 128.03869,
    r: 10.72581,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 490.13546,
    cy: 128.03869,
    r: 6.89516,
    fill: "#0ac5a8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M567.71129,268.19066a20.63132,20.63132,0,0,0-20.608,18.69534l-2.14464,21.98095a18.78988,18.78988,0,0,0,18.701,20.614h56.48406a18.78986,18.78986,0,0,0,18.70095-20.614L636.69994,286.886a20.63132,20.63132,0,0,0-20.608-18.69534Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M597.62489,299.26831a10.00833,10.00833,0,0,1,13.9803-2.06658,10.00882,10.00882,0,1,0-13.9803,2.06658Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M574.27185,301.19976a10.00836,10.00836,0,0,1,13.9803-2.06658,10.00882,10.00882,0,1,0-13.9803,2.06658Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 456.14424,
    cy: 151.81396,
    r: 3.68732,
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 480.02404,
    cy: 149.00457,
    r: 3.68732,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 467.38988,
    cy: 164.81289,
    r: 3.83065,
    fill: "#0ac5a8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M576.85172,310.32775a8.43909,8.43909,0,0,0,8.393,7.66129h15.323a8.43837,8.43837,0,0,0,8.39225-7.66129Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M354.64352,278.5334a10.72581,10.72581,0,1,1-21.45161,0c0-5.9237,4.80211-30.64516,10.72581-30.64516S354.64352,272.6097,354.64352,278.5334Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M350.81288,278.5334a6.89516,6.89516,0,0,1-13.79032,0c0-3.80809,3.08707-26.81452,6.89516-26.81452S350.81288,274.72531,350.81288,278.5334Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M379.15965,278.5334a10.72581,10.72581,0,1,0,21.45162,0c0-5.9237-4.80211-32.94355-10.72581-32.94355S379.15965,272.6097,379.15965,278.5334Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M382.9903,278.5334a6.89516,6.89516,0,0,0,13.79032,0c0-3.80809-3.08707-29.1129-6.89516-29.1129S382.9903,274.72531,382.9903,278.5334Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M342.71129,279.29953a20.63132,20.63132,0,0,0-20.608,18.69534l-2.14464,21.981a18.78988,18.78988,0,0,0,18.701,20.614h56.48406a18.78986,18.78986,0,0,0,18.70095-20.614l-2.14463-21.981a20.63132,20.63132,0,0,0-20.60805-18.69534Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M372.62489,310.37718a10.00833,10.00833,0,0,1,13.9803-2.06658,10.00882,10.00882,0,1,0-13.9803,2.06658Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M349.27185,312.30864a10.00835,10.00835,0,0,1,13.9803-2.06659,10.00881,10.00881,0,1,0-13.9803,2.06659Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.14424,
    cy: 169.05186,
    r: 3.68732,
    fill: "#e6e6e6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.79017,
    cy: 167.0086,
    r: 3.68732,
    fill: "#e6e6e6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.38988,
    cy: 175.92176,
    r: 3.83065,
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M375.15231,318.10027c1.31041-.682,2.80377-.226,4.086.30021,1.40323.57584,2.76414,1.2288,4.21034,1.69823a17.09506,17.09506,0,0,0,8.41318.73254c5.10278-.95407,9.38433-5.51487,8.23779-10.92377-.30655-1.44616-2.52262-.83417-2.21629.611a6.46711,6.46711,0,0,1-2.05964,5.93938,9.73141,9.73141,0,0,1-6.75238,2.33026,20.0732,20.0732,0,0,1-7.84056-2.00857c-2.34061-1.0364-4.79608-1.935-7.23847-.66387-1.31253.68312-.1517,2.6673,1.16,1.98459Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M360.577,316.11568c-2.38007-1.23874-4.7882-.41606-7.081.5938a20.52985,20.52985,0,0,1-7.998,2.07864,9.775,9.775,0,0,1-6.64519-2.23338,6.48931,6.48931,0,0,1-2.16683-6.03626c.30584-1.44279-1.90925-2.05947-2.21628-.611-1.14652,5.40875,3.135,9.9697,8.23778,10.92377a17.062,17.062,0,0,0,8.41319-.73254c1.44577-.47156,2.807-1.12179,4.21034-1.69823,1.28056-.526,2.77644-.98178,4.086-.30021,1.31047.68205,2.474-1.30073,1.16-1.98459Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#fff"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.30078,
    cy: 186.2645,
    rx: 6.12903,
    ry: 3.06452,
    fill: "#fff"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 653.46207,
    cy: 137.32494,
    r: 21.63687,
    fill: "#3f3d56"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 653.46207,
    cy: 137.32494,
    r: 13.90942,
    fill: "#0ac5a8"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 730.8411,
    cy: 137.32494,
    r: 21.63687,
    fill: "#3f3d56"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 730.8411,
    cy: 137.32494,
    r: 13.90942,
    fill: "#0ac5a8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M793.09435,269.81561q-.502,0-.99836.02339c-12.4675.58529-21.08618,12.78889-18.04794,24.89468l.44011,1.75363c1.56349,6.22968,2.62749,12.56382,3.68105,18.89971a18.78407,18.78407,0,0,0,18.5347,15.71892h41.16148a18.78608,18.78608,0,0,0,18.66986-16.68618,130.22515,130.22515,0,0,1,3.30816-16.98522l.67785-2.70085c3.03824-12.1058-5.58044-24.3094-18.04794-24.89469q-.49629-.02331-.99837-.02339Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M823.008,300.89327a10.00836,10.00836,0,0,1,13.98031-2.06659,10.00881,10.00881,0,1,0-13.98031,2.06659Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M799.65491,302.82472a10.00834,10.00834,0,0,1,13.98031-2.06658,10.00882,10.00882,0,1,0-13.98031,2.06658Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#fff"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 677.69665,
    cy: 153.43892,
    r: 3.68732,
    fill: "#3f3d56"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 701.57646,
    cy: 152.16179,
    r: 3.68732,
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M821.35359,305.82368a3.83065,3.83065,0,1,1-6.75206-2.47786c.70265-.82761,1.51241,1.71173,2.68312,1.71173,1.21234,0,2.53143-2.50133,3.23334-1.62232A3.81453,3.81453,0,0,1,821.35359,305.82368Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#0ac5a8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M684.34553,171.80075h18.3871a0,0,0,0,1,0,0v0a9.19354,9.19354,0,0,1-9.19354,9.19354h0a9.19354,9.19354,0,0,1-9.19354-9.19354v0A0,0,0,0,1,684.34553,171.80075Z",
    fill: "#fff"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 689.8532,
    cy: 126.59913,
    rx: 4.97984,
    ry: 8.42742,
    fill: "#0ac5a8"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 822.26449,
    cy: 267.51723,
    rx: 8.42742,
    ry: 4.97984,
    transform: "translate(6.76136 648.27029) rotate(-55.00173)",
    fill: "#0ac5a8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M431.63237,369.68518H302.17081a6.92409,6.92409,0,0,1-6.916-6.91594V223.41046a6.92409,6.92409,0,0,1,6.916-6.91594H431.63237a6.92408,6.92408,0,0,1,6.91594,6.91594V362.76924A6.92408,6.92408,0,0,1,431.63237,369.68518ZM302.17081,219.2609a4.1541,4.1541,0,0,0-4.14957,4.14956V362.76924a4.1541,4.1541,0,0,0,4.14957,4.14956H431.63237a4.15411,4.15411,0,0,0,4.14957-4.14956V223.41046a4.15411,4.15411,0,0,0-4.14957-4.14956Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M656.63237,369.68518H527.17081a6.92409,6.92409,0,0,1-6.91595-6.91594V223.41046a6.92409,6.92409,0,0,1,6.91595-6.91594H656.63237a6.92408,6.92408,0,0,1,6.91594,6.91594V362.76924A6.92408,6.92408,0,0,1,656.63237,369.68518ZM527.17081,219.2609a4.1541,4.1541,0,0,0-4.14957,4.14956V362.76924a4.1541,4.1541,0,0,0,4.14957,4.14956H656.63237a4.15411,4.15411,0,0,0,4.14957-4.14956V223.41046a4.15411,4.15411,0,0,0-4.14957-4.14956Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M881.63237,369.68518H752.17081a6.92409,6.92409,0,0,1-6.91595-6.91594V223.41046a6.92409,6.92409,0,0,1,6.91595-6.91594H881.63237a6.92408,6.92408,0,0,1,6.91594,6.91594V362.76924A6.92408,6.92408,0,0,1,881.63237,369.68518ZM752.17081,219.2609a4.1541,4.1541,0,0,0-4.14957,4.14956V362.76924a4.1541,4.1541,0,0,0,4.14957,4.14956H881.63237a4.15411,4.15411,0,0,0,4.14957-4.14956V223.41046a4.15411,4.15411,0,0,0-4.14957-4.14956Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#e6e6e6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M784.90159,385.4678a1.00068,1.00068,0,0,0-1,1v8a1.00067,1.00067,0,0,0,1,1h64a1.00067,1.00067,0,0,0,1-1v-8a1.00068,1.00068,0,0,0-1-1Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M559.90159,385.4678a1.00068,1.00068,0,0,0-1,1v8a1.00067,1.00067,0,0,0,1,1h64a1.00067,1.00067,0,0,0,1-1v-8a1.00068,1.00068,0,0,0-1-1Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#0ac5a8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M334.90159,385.4678a1.00068,1.00068,0,0,0-1,1v8a1.00067,1.00067,0,0,0,1,1h64a1.00067,1.00067,0,0,0,1-1v-8a1.00068,1.00068,0,0,0-1-1Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#e6e6e6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M301.75,517.11417l-3,13s1,30-7,27-6-29-6-29l7-13Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#ffb8b8"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 215.22833,
    r: 20,
    fill: "#ffb8b8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M241.75,360.11417l-2,29,25,3s0-24,2-27S241.75,360.11417,241.75,360.11417Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#ffb8b8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M297.19191,397.88014,264.7972,384.19505s-15.47946-11.9226-24.54586-3.08988l-4.069,5.82834S200.19458,400.965,200.2042,411.965l14.0481,54.98773s-7.97287,31.007,4.02887,32.99649l65.00522,5.94314s8.99038-11.00787.97813-25.00087l2.97114-33.00261Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#e6e6e6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M275.1928,398.89939l21.99911-1.01925s7.00175,1.99388,12.01837,20.9895,6.04374,49.99473,6.04374,49.99473l-11.951,56.01048L288.30126,522.888l5.95276-54.00523L284.22254,432.8915Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#e6e6e6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M212.19807,404.9545l-10.8435,3.38753s-9.14162,13.63-9.1355,20.62995-3.94751,60.00348-3.94751,60.00348l26.0376,42.97724,7.98163-21.007-16.02361-26.986,12.97113-33.01136Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#e6e6e6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M286.25,503.61417l-71.8968-6.32585s-7.1032,45.32585-6.1032,63.32585,2,46,2,46l-8,122,31-4,4-101,13-55,15,70,10,90,27-3-9-109S301.25,518.61417,286.25,503.61417Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#2f2e41"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M296.25,720.61417l9,3s19-5,14,8-19,11-19,11-17,13-24,3l4-21Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#2f2e41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M223.25,720.61417l9,3s19-5,14,8-19,11-19,11-17,13-24,3l4-21Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#2f2e41"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M241.75,372.11417s-21-15-10-33c7.63118-12.48738,23.44411-11.49893,32.414-9.72226a15.154,15.154,0,0,1,11.086,8.72226c1.5,3.5,1.5,7-4.5,7-12,0-6,9-6,9s-8,2-6,9S241.75,372.11417,241.75,372.11417Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#2f2e41"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M960.57123,723.33886s-22.17658,1.70589-19.90205,9.66671,19.90205,6.82356,19.90205,6.82356,13.64712-1.13726,21.03931,1.13726,15.92165,0,16.49028-3.98041-3.98041-6.82356-3.98041-6.82356l-2.84315-5.6863Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#2f2e41"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M902.28664,545.64194,900.01212,554.74s-10.23534,21.03932,2.27452,21.03932,7.96082-19.33343,7.96082-19.33343l1.13726-9.09808Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#9f616a"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.03226,538.24975l2.27452,9.09808s10.23534,21.03932-2.27452,21.03932-7.96083-19.33343-7.96083-19.33343l-1.13726-9.09808Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#9f616a"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 828.14472,
    cy: 219.74543,
    r: 24.4511,
    fill: "#9f616a"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M945.50253,377.89605s2.84315,13.0785,1.13726,19.33343,35.25507-1.13726,35.25507-1.13726-13.07849-21.608-12.50986-22.17658Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#9f616a"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M951.12618,392.37438s-10.23782-2.8342-13.64662.58056-23.30239,13.09889-23.30239,13.09889l13.72024,83.57665,59.12607-13.13022,10.1662-79.04851s-16.13328-9.4414-18.8731-7.5544S951.12618,392.37438,951.12618,392.37438Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#e6e6e6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M918.72671,406.61848l-2.73053-1.46134s-10.34746,2.04141-9.77187,10.00173,2.88892,52.31146,2.88892,52.31146l-9.028,80.18478,16.49276,2.82872,16.43157-67.11275Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#e6e6e6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M995.48528,399.15914l2.728-1.46611s10.351,2.0233,9.78935,9.98461-2.79739,52.31644-2.79739,52.31644l9.16822,80.16886-16.48778,2.85757-16.549-67.0839Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#e6e6e6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M928.44363,481.38674l-2.27452,34.68644-7.39219,69.37287,10.804,143.86342,37.52959,1.13726L955.73787,593.40687l11.37261-47.1963,37.17363-1.3768s2.63047-54.34895-18.40884-71.40785Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "844.635 398.864 838.664 524.247 836.674 587.649 870.223 591.061 878.688 404.602 865.674 391.472 844.635 398.864",
    fill: "#2f2e41"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M963.6987,326.71934s-22.17658-2.84315-28.43151,7.96082c0,0-1.70589,7.96083-7.39219,10.804s1.13726,12.50986,2.84315,15.353,6.25493,19.33343,1.13726,23.31384,9.09808,15.353,9.09808,15.353,6.82356,9.09808,1.13726,15.92164,7.39219,9.09808,7.39219,9.09808-2.84315,19.33343,2.27452,14.21576c0,0,2.27452,43.78452,23.88247,16.49027s30.706-40.37274,21.60794-51.17671-2.27452-20.47068-2.27452-20.47068,2.84315-5.68631-3.41178-14.21576S985.30664,326.71934,963.6987,326.71934Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#2f2e41"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M931.57109,726.75064s-22.17657,1.70589-19.90205,9.66671,19.90205,6.82356,19.90205,6.82356,13.64713-1.13726,21.03932,1.13726,15.92164,0,16.49027-3.98041-3.98041-6.82356-3.98041-6.82356l-2.84315-5.6863Z",
    transform: "translate(-124.75 -139.38583)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "555.214 119.691 522.749 100.132 532.23 136.83 537.945 123.46 547.477 136.242 550.304 134.134 540.772 121.352 555.214 119.691",
    fill: "#0ac5a8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "599.108 119.691 631.573 100.132 622.092 136.83 616.377 123.46 606.845 136.242 604.018 134.134 613.55 121.352 599.108 119.691",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtt);
export default __webpack_public_path__ + "static/media/ttt.14e11769d25713ac28892ef9f5a2c110.svg";
export { ForwardRef as ReactComponent };